import { render, staticRenderFns } from "./com-equ-list.vue?vue&type=template&id=21e05c9a&scoped=true&"
import script from "./com-equ-list.vue?vue&type=script&lang=js&"
export * from "./com-equ-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e05c9a",
  null
  
)

export default component.exports